export const pt = {
  title: 'Potencial de velocidade do vento',
  subtitle: '1 km, global, DTU/Grupo Banco Mundial/ESMAP',
  download_data: '',
  learn_more: '',
  content: [
    {
      label: 'Função',
      value: 'Velocidade média do vento para qualquer local da Terra',
    },
    {
      label: 'Resolução',
      value: '1 km',
    },
    {
      label: 'Cobertura geográfica',
      value: 'Global',
    },
    {
      label: 'Fonte',
      value: '\tDTU/Grupo Banco Mundial/ESMAP',
    },
    {
      label: 'Frequência de atualizações',
      value: '',
    },
    {
      label: 'Dados de conteúdo',
      value: '',
    },
    {
      label: 'Precauções',
      value:
        'O GWA usa dois componentes principais de modelagem que podem introduzir incerteza nos cálculos. Esses componentes são a modelagem em mesoescala e a modelagem em microescala.',
    },
    {
      label: 'Licença',
      value: '[CC 4.0](https://creativecommons.org/licenses/by/4.0/)',
    },
  ],
  overview: {
    label: 'Visão geral',
    value:
      'O conjunto de dados de velocidade média do vento do Atlas Global do Vento (GWA) foi gerado pelo Departamento de Energia Eólica da Universidade Técnica da Dinamarca (DTU), pelo Grupo Banco Mundial e pelo Programa de Assistência à Gestão do Setor de Energia (ESMAP).\n\nA velocidade média do vento é um dos principais indicadores de desempenho da produção de energia eólica. A GWA começa com dados de velocidade do vento de baixa resolução e os converte em dados de alta resolução usando um processo de downscaling. O resultado desse processo é um modelo de climas de vento locais em todo o globo (exceto os pólos norte e sul e áreas oceânicas distantes) com resolução de 1 quilômetro para três alturas: 50 metros, 100 metros e 200 metros.',
  },
  citation: {
    label: 'Citação',
    value:
      'Data/information/map obtained from the Global Wind Atlas 2.0, a free, web-based application developed, owned and operated by the Technical University of Denmark (DTU) in partnership with the World Bank Group, utilizing data provided by Vortex, with funding provided by the Energy Sector Management Assistance Program (ESMAP). For additional information: https://globalwindatlas.info. Accessed through Resource Watch, (date)',
  },
};
